import { InformationContainer } from "../welcomeBanner/WelcomeBanner.styled";
import {
  Description,
  InformationContainerInner,
  SpondGroupContainer,
  Subheading,
  SubmitButton,
  SvgDotPattern1,
} from "./SpondGroups.styles";
import { ReactComponent as GroupButtonIcon } from "feather-icons/dist/icons/users.svg";

const SpondGroups = ({ isAdult, memberDetails }) => {
  return (
    <InformationContainer>
      <SvgDotPattern1 />
      <InformationContainerInner></InformationContainerInner>
      <Subheading>Your Spond Groups</Subheading>
      <Description>
        If you haven't already done so, use the link(s) below to join the Spond
        group(s) for which you're eligible. We use Spond to book and pay for
        sessions.
      </Description>
      <SpondGroupContainer>
        {isAdult && (
          <SubmitButton
            onClick={(e) => {
              window.location.href = "https://group.spond.com/RVWIF";
            }}
            type="button"
          >
            <GroupButtonIcon className="icon" />
            <span className="text">JOIN SENIORS GROUP</span>
          </SubmitButton>
        )}
        {(!isAdult || memberDetails.isJuniorCoach) && (
          <SubmitButton
            onClick={(e) => {
              window.location.href = "https://group.spond.com/JZDVE";
            }}
            type="button"
          >
            <GroupButtonIcon className="icon" />
            <span className="text">JOIN JUNIORS GROUP</span>
          </SubmitButton>
        )}
      </SpondGroupContainer>
    </InformationContainer>
  );
};

export default SpondGroups;
